import { motion } from "framer-motion"
import ai from '../../assets/Capability/Ai.avif'
import code from '../../assets/Capability/app.avif'
import ui from '../../assets/Capability/ui.avif'
import embeded from '../../assets/Capability/embedded.avif'
import digital from '../../assets/Capability/digitalMarket.avif'
import web from '../../assets/Capability/web.avif'
import mobile from '../../assets/Capability/mobileApp.avif'
import product from '../../assets/Capability/productDevelop.avif'
import Enterprise from '../../assets/Capability/enterprise.avif'
import aiDesign from '../../assets/Capability/ai&ml.avif'
import automation from '../../assets/Capability/automation.avif'
import data from '../../assets/Capability/data analytics.avif'
import business from '../../assets/Capability/businessIntelligent.avif'
import uiux from '../../assets/Capability/uiux.avif'
import design from '../../assets/Capability/design.avif'
import brand from '../../assets/Capability/brand.avif'
import experience from '../../assets/Capability/digitalExp.avif'
import iot from '../../assets/Capability/iot.avif'
import hardware from '../../assets/Capability/hardware.avif'
import monitor from '../../assets/Capability/controlsystem.avif'
import smartDevice from '../../assets/Capability/smart device.avif'
import digitalMarket from '../../assets/Capability/digital.avif'
import performance from '../../assets/Capability/performance.avif'
import seo from '../../assets/Capability/Seo.avif'
import growth from '../../assets/Capability/growth.avif'
import { useLocation } from "react-router-dom"
import { useEffect } from "react"


export default function OurCapable() {
    const location = useLocation()
    useEffect(() => {

        if (location.hash) {

            const sectionId = decodeURIComponent(location.hash.replace("#", ""));

            const element = document.getElementById(sectionId);

            if (element) {

                const navbarHeight = 120;

                const top =
                    element.getBoundingClientRect().top +
                    window.scrollY -
                    navbarHeight;

                window.scrollTo({
                    top,
                    behavior: "smooth",
                });
            }
        }

    }, [location]);

    const capable = [
        {
            title: "Engineering & Platforms",
            image: code,
            content: [
                { name: 'Web Development', point: web },
                { name: 'Mobile Application Development', point: mobile },
                { name: 'Product Development', point: product },
                { name: 'Enterprise Systems', point: Enterprise }
            ]
        },
        {
            title: 'Intelligence & Automation',
            image: ai,
            content: [
                { name: 'AI & Machine Learning', point: aiDesign },
                { name: 'Intelligent Automation', point: automation },
                { name: 'Data & Analytics', point: data },
                { name: 'Business Intelligence Systems', point: business }
            ]
        },
        {
            title: "Design & Experience",
            image: ui,
            content: [
                { name: 'UI / UX Design', point: uiux },
                { name: 'Design Strategy', point: design },
                { name: 'Brand Systems', point: brand },
                { name: 'Digital Experience Design', point: experience }
            ]
        },
        {
            title: 'Connected Systems',
            image: embeded,
            content: [
                { name: 'IoT Solutions', point: iot },
                { name: 'Hardware Integration', point: hardware },
                { name: 'Monitoring & Control Systems', point: monitor },
                { name: 'Smart Device Platforms', point: smartDevice }
            ]
        },
        {
            title: 'Growth & Visibility',
            image: digital,
            content: [
                { name: 'Digital Marketing', point: digitalMarket },
                { name: 'Performance Marketing', point: performance },
                { name: 'Search Engine Optimization (SEO)', point: seo },
                { name: 'Growth Analytics', point: growth }
            ]
        }
    ]


    const sectionVariant = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, staggerChildren: 0.15 }
        }
    }

    const cardVariant = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0 }
    }

    return (
        <section className="py-8 md:py-12 bg-[#F4F5F6] px-6 lg:px-24 snap-y snap-mandatory lg:snap-none">

            <div className="mx-auto max-w-7xl">


                <h2 className="text-black text-4xl py-4 font-semibold sticky top-[70px] z-40 bg-[#F4F5F6] lg:static">
                    Our Capabilities
                </h2>

                {capable.map((product, index) => (

                    <motion.div
                        key={index}
                        className="py-6 snap-start"
                        variants={sectionVariant}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        id={product.title}
                    >

                        {/* STICKY TITLE WRAPPER */}
                        <div className="sticky top-[134px] z-40 bg-[#F4F5F6] lg:static">

                            <p className="bg-clip-text text-transparent bg-gradient-to-r from-primary-900 to-secondary-400 text-2xl font-medium py-3">
                                {product.title}
                            </p>

                        </div>


                        {/* MAIN SECTION */}
                        <div
                            className={`
                flex flex-col lg:flex-row gap-6 my-7
                ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}
            `}
                        >

                            {/* CONTENT */}
                            <div className="w-full lg:w-1/2 flex flex-col">

                                {product.content.map((points, i) => (

                                    <motion.div
                                        key={i}
                                        variants={cardVariant}
                                        className="
                            group flex gap-3 items-center
                            py-3 px-5
                            hover:bg-secondary-100
                            w-full
                            min-h-[100px]
                            bg-white rounded-lg mt-[2px]
                        "
                                    >

                                        {/* IMAGE BOX */}
                                        <span
                                            className="
                                relative flex items-center justify-center
                                w-[110px] h-[70px]
                                bg-gray-400 rounded-lg

                                lg:w-4 lg:h-4
                                lg:bg-black lg:rounded-sm

                                lg:group-hover:w-[150px]
                                lg:group-hover:h-[80px]
                                lg:group-hover:bg-gray-400
                                lg:group-hover:rounded-lg

                                transition-all duration-700
                                overflow-hidden
                            "
                                        >

                                            <img
                                                src={points.point}
                                                alt={points.name}
                                                className="
                                    opacity-100
                                    lg:opacity-0
                                    lg:group-hover:opacity-100
                                    w-full h-full object-cover
                                    transition-opacity duration-500
                                "
                                            />

                                        </span>


                                        <p className="font-secondary text-black group-hover:text-secondary-500 text-base md:text-xl">
                                            {points.name}
                                        </p>

                                    </motion.div>

                                ))}

                                 <a
                                    href={`/services#${product.title} `}
                                    className=" text-primary-700
                        hover:text-primary-900
                        font-medium
                        py-2 inline-block mt-2
                        transition-colors duration-300
                    "
                                >
                                    Explore More
                                </a>

                            </div>


                            {/* RIGHT IMAGE */}
                            <div className="hidden lg:block lg:w-1/2">

                                <img
                                    src={product.image}
                                    alt={product.title}
                                    className="
                        w-full h-full
                        object-cover
                        rounded-[40px]
                    "
                                />

                            </div>

                        </div>

                    </motion.div>

                ))}

            </div>

        </section>
    )
}



// {
//     capable.map((product, index) => (

//         <motion.div
//             key={index}
//             className="py-6 snap-start"
//             variants={sectionVariant}
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.2 }}
//             id={product.title}
//         >

//             {/* STICKY TITLE WRAPPER */}
//             <div className="sticky top-[130px] z-40 bg-[#F4F5F6] lg:static">

//                 <p className="bg-clip-text text-transparent bg-gradient-to-r from-primary-900 to-secondary-400 text-2xl font-medium py-3">
//                     {product.title}
//                 </p>

//             </div>


//             <div className={`flex flex-col lg:justify-around my-7 items-center ${index % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"}`}>

//                 {/* CONTENT */}
//                 <div className="w-full">

//                     {product.content.map((points, i) => (

//                         <motion.div
//                             key={i}
//                             variants={cardVariant}
//                             className="group flex gap-3 items-center py-3 px-5 hover:bg-secondary-100 w-full lg:max-w-[580px] min-h-[100px] bg-white rounded-lg mt-[2px]"
//                         >

//                             {/* IMAGE BOX */}
//                             <span className="
//                       relative flex items-center justify-center
//                       w-[110px] h-[70px] bg-gray-400 rounded-lg
//                       lg:w-4 lg:h-4 lg:bg-black lg:rounded-sm
//                       lg:group-hover:w-[150px] lg:group-hover:h-[80px]
//                       lg:group-hover:bg-gray-400 lg:group-hover:rounded-lg
//                       transition-all duration-700 overflow-hidden
//                     ">

//                                 <img
//                                     src={points.point}
//                                     alt={points.name}
//                                     className="
//                           opacity-100
//                           lg:opacity-0 lg:group-hover:opacity-100
//                           w-full h-full object-cover
//                           transition-opacity duration-500
//                         "
//                                 />

//                             </span>


//                             <p className="font-secondary text-black group-hover:text-secondary-500 text-base md:text-xl">
//                                 {points.name}
//                             </p>

//                         </motion.div>

//                     ))}
//                     <a href="#" className="text-primary-700 hover:text-primary-900 font-medium px-0 py-2 inline-block mt-2 transition-colors duration-300">
//                         Explore More
//                     </a>
//                 </div>


//                 {/* RIGHT IMAGE (DESKTOP ONLY) */}
//                 <div className="hidden lg:block flex-1 h-auto">
//                     <img
//                         src={product.image}
//                         alt={product.title}
//                         className="  w-full h-full object-cover rounded-[40px]"
//                     />

//                 </div>
//             </div>

//         </motion.div>

//     ))
// }
